"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.AccountChip = exports.AccountHorizontalList = exports.RetrofitSettingsLayout = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _reactI18next = require("react-i18next");

var _classnames = _interopRequireDefault(require("classnames"));

var _Tooltip = _interopRequireDefault(require("../Tooltip"));

var _Layout = _interopRequireDefault(require("../../screens/Settings/components/Layout"));

var _HorizontalList = _interopRequireDefault(require("../HorizontalList"));

var _animations = require("../../hooks/animations");

var AccountList = function AccountList(_ref) {
  var accountImportButton = _ref.accountImportButton,
      _ref$showDivider = _ref.showDivider,
      showDivider = _ref$showDivider === void 0 ? true : _ref$showDivider,
      children = _ref.children;
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "mb-6"
  }, children), showDivider && /*#__PURE__*/_react["default"].createElement("hr", {
    className: "-mx-6"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "py-3"
  }, accountImportButton));
};

var RetrofitSettingsLayout = function RetrofitSettingsLayout(props) {
  var _useTranslation = (0, _reactI18next.useTranslation)(),
      t = _useTranslation.t;

  return /*#__PURE__*/_react["default"].createElement(_Layout["default"], (0, _extends2["default"])({
    header: t('retrofit')
  }, props));
};

exports.RetrofitSettingsLayout = RetrofitSettingsLayout;
var HEIGHT = 100;
var COLUMN_WIDTH = 380;

var AccountHorizontalList = function AccountHorizontalList(_ref2) {
  var enableOffset = _ref2.enableOffset,
      accounts = _ref2.accounts,
      _cellRenderer = _ref2.cellRenderer,
      columnWidth = _ref2.columnWidth;

  var _useVirtualizedList = (0, _animations.useVirtualizedList)(accounts, ['ecUUID']),
      data = _useVirtualizedList.data,
      removedIndexes = _useVirtualizedList.removedIndexes;

  var getColumnWidth = (0, _react.useCallback)(function (_ref3) {
    var index = _ref3.index;
    if (removedIndexes.includes(index)) return 0;
    return columnWidth || COLUMN_WIDTH;
  }, [data, removedIndexes]);
  return /*#__PURE__*/_react["default"].createElement(_HorizontalList["default"], {
    invert: false,
    count: data.length,
    height: HEIGHT,
    rowHeight: HEIGHT,
    columnWidth: getColumnWidth,
    enablePagination: false,
    className: "card-list",
    cellRenderer: function cellRenderer(_ref4) {
      var key = _ref4.key,
          columnIndex = _ref4.columnIndex,
          style = _ref4.style;

      var _ref5 = data[columnIndex] || {},
          _className = _ref5._className,
          cell = (0, _objectWithoutProperties2["default"])(_ref5, ["_className"]);

      return _cellRenderer({
        data: cell,
        style: style,
        className: (0, _classnames["default"])('card-list-item', _className)
      });
    }
  });
};

exports.AccountHorizontalList = AccountHorizontalList;

var AccountChip = function AccountChip(_ref6) {
  var avatar = _ref6.avatar,
      name = _ref6.name,
      emailAddress = _ref6.emailAddress,
      _onClick = _ref6.onClick;

  var _useTranslation2 = (0, _reactI18next.useTranslation)(),
      t = _useTranslation2.t;

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "p-4 h-full"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex items-center dark:bg-secondary shadow-lg dark:shadow-shallow px-6 py-4 h-full"
  }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].cloneElement(avatar, {
    className: '!w-10 !h-10'
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-grow flex items-center truncate mx-4 min-w-0"
  }, name && /*#__PURE__*/_react["default"].createElement(_Tooltip["default"], {
    title: name
  }, /*#__PURE__*/_react["default"].createElement("p", {
    className: "truncate"
  }, name)), /*#__PURE__*/_react["default"].createElement(_Tooltip["default"], {
    title: emailAddress
  }, /*#__PURE__*/_react["default"].createElement("p", {
    className: "truncate text-sm text-medium"
  }, emailAddress))), /*#__PURE__*/_react["default"].createElement("button", {
    className: "font-bold text-primary text-sm",
    onClick: function onClick() {
      return _onClick();
    }
  }, t('button.remove'))));
};

exports.AccountChip = AccountChip;
var _default = AccountList;
exports["default"] = _default;
//# sourceMappingURL=AccountList.js.map